<template>
  <div class="checkout">
    <Top />
    <div class="soso-tab">
      <div class="soso-center">
        <h3 class="soso-title">确认订单</h3>
      </div>
    </div>
    <div class="cart-mores fix" v-if="LoadingCart"><img src="../assets/car.gif" alt="正在为您加载数据..."></div>
    <div class="wrap1200 top20 fix" v-else>
    
      <div class="table-material">        
          <div class="cartTable addressTable" v-if="adrList.length > 0">
            <div class="title">
              <span class="address-ok-title">确认收货地址</span>{{`（已保存了${adrList.length }条地址，还能添加${20-adrList.length}条地址）`}}
              <a href="javascript: void(0);" class="add"  @click="clickAddr()">新增收货地址</a>
            </div>
            <table width="100%" v-show="upSwitch || idx < 3" :class="{ 'addressDetail': true, 'name-selected-border': idx == onIdx } " v-for="(item,idx) in adrList" :key="item.id">
              <tbody>
                <tr>
                  <td width="30" @click="onSeelect(item,idx)"><span :class="{'name icons': true, 'name-selected': idx == onIdx }"></span></td>
                  <td width="100" title=""><span class="node-contact">{{ item.linkMan }}</span></td>
                  <td width="100" title=""><span class="node-phone">{{ item.phone }}</span></td>
                  <td class="textLeft">
                    <span class="node-address" :title="(item.provinceName != item.cityName && item.provinceName || '')+ item.cityName + item.districtName + item.address">{{item.provinceName != item.cityName && item.provinceName || ''}}{{item.cityName}}{{item.districtName}}{{item.address}}</span>
                  </td>
                  <td width="100"><a class="default" v-if="item.isDefault != 1">（默认地址）</a></td>
                  <td width="160">
                    <a class="action" @click="clickAddr(item)" title="修改地址">修改地址</a>
                    <a  v-if="item.isDefault == 1" class="action" @click="onDefault(item.id,idx)" title="设为默认">设为默认</a>
                  </td>
                </tr>
              </tbody>
            </table>
            
            <div class="actionSwitch" @click="upSwitch = !upSwitch">
              <span>{{ upSwitch ? '收起地址' : '更多地址'}}</span>
              <i class="icons" :class="{'b-top': !upSwitch, 'b-bottom': upSwitch}"></i>
            </div>
        </div>
        <p v-else>您还没有收货地址，请<a href="javascript: void(0);"   @click="clickAddr()"><b class="addr-red">添加收货地址</b></a></p>

        <Addr :show="addrShow" :item="addrItem" @addrOk="addrOk"/>
      </div>

      <div class="checkout-form fix" v-if="carts.cartDetails.length > 0">
        <div class="big-title fix"><span>确认订单信息</span></div>
        <div class="preview-item fix " :class="{'no-submit': !points || carts.isExchange != 20}">
          <div class="store">
            <strong class="name">
              <i class="icons icon-shop"></i>
              <router-link :to="`/${carts.merchantCode}`"><span>{{carts.merchantName}}</span></router-link>
            </strong>
          </div>
          <div class="pay-info">
            <h5 class="title">支付方式</h5>
            <div class="type"><span class="item on"><span>积分兑换</span><i class="icon"></i></span></div>
            <div class="type-desc on">
              <template v-if="carts.isExchange == 20">
                <p  v-if="points">将从 店铺积分 扣减积分</p>
                <p  class="red" v-if="!points">店铺积分余额不足</p>
              </template>
              <p  class="red" v-else>该店铺积分兑换已禁用</p> 
            </div>
            
          </div>

          <div class="products-check">
            <div class="cart-box">
              <template v-for="(item,idx) in carts.cartDetails">
                <div class="cart-entry-box" v-if="item.stock != 0 && item.status != 20 && item.auditStatus == 2" :key="idx">
                  <div class="cart-entry fix">
                    <router-link class="product fix" :to="`/product/${carts.merchantCode}/${item.productCode}`">
                      <div class="pic">
                        <img v-if="item.imageUrl" :src="item.imageUrl" >
                        <img v-else src='../assets/no-picture.png' :title="item.productName"/>
                      </div>
                      <div class="info">
                        <h5 class="name" :title="item.productName">{{item.productName}}</h5>
                        <p class="message"><span>编号：</span><span>{{item.productCode}}</span><span >&nbsp;&nbsp;&nbsp;售价单位：</span><span >{{item.saleUnit}}</span></p>
                      </div>
                      <div v-if="item.msg" class="red">{{item.msg}}</div>
                    </router-link>
                    <div class="price-info"><span class="one-price"><span class="price" ><IconJifen size="gray" :points="item.price" /></span></span><span >x</span>
                      <span class="quantity" >{{item.quantity}}</span><span >=</span><span class="total-price" ><IconJifen size="gray" :points="item.amount" /></span>
                    </div>
                  </div>
                </div>
              </template>
            </div>

            <div class="count fix">
              <div class="markup">
                <span>订单留言：</span>
                <textarea rows="2" maxlength="45" cols="20" v-model="memo" class="textarea" name="comment" type="text" placeholder="选填，可填写您和卖家达成一致的要求，限45个字"></textarea>
              </div>
              <div class="subtotal">
                <div>
                  <span>礼品合计：</span>
                  <strong class="normal-price"><IconJifen size="mini" :points="totalAmount" /></strong>
                </div>
                <div>
                  订单总价：<IconJifen  size="mini" :points="totalAmount" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <button class="balanceLink checked" @click="onSubmit" disabled>提交订单</button> -->
        <z-button v-if="!LoadingScroll" size='submit' @click='onSubmit'>提交订单</z-button>
        <z-button v-else size='submit'>提交中...</z-button>
      </div>

      <confirm titleTig="提交订单信息有误" :okText="okText" :noCloseTag='noCloseTag' :closeText="closeText" :message='message' @confirmok="confirmok" :shows="show"></confirm>

    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Top from "../components/top";
import Confirm from "../components/confirm/main.vue";
import IconJifen from "../components/icon-jifen";
import ZButton from "../components/zButton";
import Addr from "../components/addr";

export default {
  name: "checkout",
  components: {
    Top,
    Confirm,
    IconJifen,
    ZButton,
    Addr
  },
  computed: {
    ...mapGetters([
      "shopInfo",
      "carts",
      "LoadingCart",
      "adrList",
      "submit",
      "LoadingScroll"
    ]),
    points: function() {
      return this.shopInfo.points >= this.getAmount(this.carts.cartDetails);
    },
    totalAmount() {
      return this.getAmount(this.carts.cartDetails);
    }
  },
  data() {
    return {
      num: 0,
      closeText: "停留本页",
      okText: '',
      noCloseTag: false,
      show: false,
      message: "",
      onIdx: 0,
      addr: '',
      memo: "",
      addrShow: false,
      addrItem: "",
      upSwitch: false
    };
  },
  created() {
    this.$store.dispatch("ALLCHECKOUT", this.$route.params.id);
    document.getElementsByTagName("body")[0].style.overflow = "auto";
  },
  watch: {
    "carts.cartDetails": function(val) {
      if (this.getAmount(val) == 0) {
        this.show = true;
        this.closeText = "";
        this.okText = '返回上一页'
        this.noCloseTag = false;
        this.message = "抱歉，礼品清单已提交或已清空。请返回上一页。";
      }
    }
  },
  methods: {
    clickAddr(item) {
      this.addrItem = item ? item : "";
      this.addrShow = true;
    },
    addrOk(o) {
      this.addrShow = false;
      if(o) {
        this.onIdx = 0,
        this.addr =  ''
      }
    },
    confirmok(k) {
      this.show = false;
      if (this.okText == '知道了') return
      if (k) this.$router.go(-1);
    },
    getAmount(arr) {
      var s = 0;
      arr &&
        arr.forEach((val) => {
          if (val.status != 20 && val.auditStatus == 2 && val.stock > 0) {
            s += val.quantity * val.price;
          }
        });
      return s;
    },
    onSeelect(v, idx) {
      this.onIdx = idx;
      this.addr = {
        phone: v.phone,
        linkMan: v.linkMan,
        address:
          (v.provinceName == v.cityName ? "" : v.provinceName) +
          v.cityName +
          v.districtName +
          v.address
      };
    },
    onDefault(id) {
      this.$store.dispatch("ADDRDEFAULT", id).then(() => {
        this.$store.dispatch("ADDRLIST");
      });
    },
    onSubmit() {
      let self = this;
      if(this.adrList.length == 0) {
        this.show = true;
        this.okText = '知道了'
        this.closeText = "";
        this.message = "请先添加收货地址！";
        return
      }
      let submit = {};
      
      if(this.addr == ''){
        this.onSeelect(this.adrList[0],0)
      }

      submit = { ...this.addr };
      submit.orderType = "10";
      submit.merchantCode = this.shopInfo.merchantCode;
      submit.memo = this.memo;
      submit.cartDetails =
        this.carts.cartDetails &&
        this.carts.cartDetails.length > 0 &&
        this.carts.cartDetails
          .map(v => {
            if (v.stock != 0 && v.status != 20 && v.auditStatus == 2)
              return {
                quantity: v.quantity,
                productCode: v.productCode,
                price: v.price
              };
          })
          .filter(v => v != undefined);
      self.$store.dispatch("SUBMIT", submit).then( res => {
        self.noCloseTag = true;
        let val = res.data;
        if (val.recode == "6003" || val.recode == "6002" || val.recode == "6001" ) {
          self.show = true;
          self.okText = '返回上一页'
          self.message = val.msg;
        } else if (val.recode == "6000") {
          self.show = true;
          self.closeText = "";
          self.noCloseTag = false;
          self.okText = '返回上一页'
          self.message = val.msg;
        } else if (val.recode == "6004" || val.recode == "6006") {
          self.show = true;
          self.okText = '返回上一页'
          self.message = val.msg;

          self.carts.cartDetails && self.carts.cartDetails.length > 0 && self.carts.cartDetails.forEach(v => {
            val.errors.forEach(k => {
              if (k.productCode == v.productCode) {
                  v.msg = k.msg;
              }
            });
          });

        } else if (val.recode == "200") {
          self.$router.push("/checkout/ok/" + this.shopInfo.merchantCode);
        }
      });
    }
  }
};
</script>
<style>
.soso-tab {
  width: 100%;
  height: 50px;
  margin: 0 auto;
  padding: 0;
  position: relative;
  border-bottom: 1px solid #ddd;
}
.soso-center {
  width: 1200px;
  line-height: 50px;
  margin: auto;
  text-align: left;
  overflow: hidden;
}
.cart-mores {
  margin: 100px auto;
  color: #999;
  width: 1200px;
}
.soso-title {
  width: 200px;
  font-size: 18px;
  display: inline;
  color: #666;
}
.table-material {
  padding: 10px 20px;
  margin: 0 0 30px 0;
  background-color: #fff;
  border: 1px solid #e7e7e7;
}
.table-material .title {
  text-align: left;
}
.address-ok-title {
  font-size: 18px;
  margin: 0;
  line-height: 40px;
}
.addressTable span {
  display: inline-block;
}
.addressTable .title .add {
  float: right;
  text-decoration: underline;
  color: #f60;
  margin-top: 10px;
  font-size: 14px;
}
.addr-red {
  color: #f60;
}
.addressTable .name {
  background-position: -28px -117px;
  display: inline-block;
  width: 20px;
  height: 20px;
  cursor: pointer;
  vertical-align: bottom;
}
.addressTable .name.name-selected {
  background-position: -28px -96px;
}
.addressTable span.node-address {
  max-width: 560px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 21px;
  display: block;
}
.addressTable .addressDetail {
  font-size: 14px;
  border: 1px solid transparent;
}

.addressTable .name-selected-border {
  border: 1px solid #fc6621;
}
.addressTable table:hover {
  background-color: #ffeede;
}

.addressTable table {
  border: none;
  border-collapse: collapse;
  position: relative;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  background-color: #fff;
  color: #666;
  table-layout: fixed;
}
table td {
  vertical-align: top;
  position: relative;
  padding: 10px;
  border-top: 1px solid #e7e7e7;
  box-sizing: initial;
}
.addressTable td {
  text-align: left;
}
.addressTable table td {
  border: none;
}
.addressTable .action {
  margin: 0 3px;
  color: #fff;
}
.addressTable table tr:hover .action {
  color: #169bd5;
  margin-left: 18px;
}
.addressTable .default {
  display: inline-block;
  color: #999;
}
.addressTable table td a {
  cursor: pointer;
}
.actionSwitch {
  height: 18px;
  line-height: 18px;
  padding: 5px 0;
  cursor: pointer;
  text-align: left;
  position: relative;
}
/* .actionSwitch .sw-icon {
  position: absolute;
  top: 14px;
  width: 0;
  margin-left: 4px;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 6px solid #999;
  -webkit-transition: -webkit-transform 0.3s;
  transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
  -webkit-transform: translateY(-50%) rotate(180deg);
  transform: translateY(-50%) rotate(180deg);
} */
/* .actionSwitch .b-top {
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
} */
.b-top {
  background-position: -20px -183px;
  display: inline-block;
  width: 15px;
  height: 9px;
  cursor: pointer;
  vertical-align: -1px;
  margin-right: 3px;
}
.b-bottom {
  background-position: -35px -183px;
  display: inline-block;
  width: 15px;
  height: 9px;
  cursor: pointer;
  vertical-align: -1px;
  margin-right: 3px;
}
.checkout-form {
  padding: 20px;
  margin: 0 0 30px 0;
  background-color: #fff;
  border: 1px solid #e7e7e7;
  text-align: left;
}
.checkout-form .big-title {
  font-size: 18px;
  color: #666;
  margin-bottom: 6px;
}

.preview-item {
  border: 4px solid #e5e5e5;
  background-color: #f5f5f5;
  margin-bottom: 20px;
}
.preview-item .store {
  height: 49px;
  line-height: 49px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #e5e5e5;
}
.preview-item .store .name {
  font-weight: 400;
  font-size: 14px;
  margin-left: 20px;
}
.preview-item .store .name .icon-shop {
  background-position: -35px 0px;
  display: inline-block;
  width: 15px;
  height: 14px;
  cursor: pointer;
  vertical-align: -2px;
  margin-right: 2px;
}
.preview-item .pay-info {
  width: 340px;
  float: left;
  padding: 0 20px 10px;
  margin-right: -1px;
  border-right: 1px solid #e5e5e5;
  box-sizing: initial;
}
.preview-item .products-check {
  background-color: #fff;
  border-left: 1px solid #e5e5e5;
  width: 769px;
  float: left;
  min-height: 205px;
}
.preview-item .pay-info .type .item {
  width: 80px;
  text-align: center;
  display: inline-block;
  height: 28px;
  line-height: 28px;
  border: 1px solid #bdbcbd;
  margin-right: 16px;
  background-color: #fff;
  color: #000;
  cursor: pointer;
  position: relative;
}
.preview-item .pay-info .type .item.on {
  width: 78px;
  height: 26px;
  line-height: 26px;
  border: 2px solid #e4393c;
}
.preview-item .pay-info .title {
  font-size: 14px;
  color: #5f5f5f;
  font-weight: 700;
  line-height: 37px;
}
.preview-item .pay-info .type .item .icon,
.warehouse .panel .icon {
  display: none;
  position: absolute;
  right: 0;
  bottom: 0;
  background: url(../assets/icon-m-h.png) no-repeat -14px -131px;
  width: 12px;
  height: 12px;
}
.preview-item .pay-info .type .item.on .icon,
.warehouse .panel.on .icon {
  display: inline-block;
}
.preview-item .pay-info .type-desc {
  color: #666;
  line-height: 20px;
  padding: 5px 0;
  display: none;
}
.preview-item .pay-info .type-desc.on {
  display: block;
}
.preview-item .red {
  color: red;
  line-height: 26px;
}
.preview-item .products-check .count {
  line-height: 26px;
  padding: 12px 8px 11px 8px;
}
.cart-entry-box {
  border-bottom: 1px solid #e5e5e5;
  width: 98%;
  margin: auto;
}
.cart-entry {
  padding: 6px 0;
}
.cart-entry-box .product {
  float: left;
}
.cart-entry-box .pic {
  width: 60px;
  height: 60px;
  float: left;
  background-color: #f4f4f4;
  margin-right: 16px;
}
.cart-entry-box .pic img {
  width: 60px;
  height: 60px;
}
.cart-entry-box .info {
  width: 320px;
  float: left;
}
.cart-entry-box .info .name {
  font-weight: 400;
  height: 36px;
  overflow: hidden;
  font-size: 12px;
}
.cart-entry-box .info .message {
  color: #999;
}
.cart-entry-box .price-info {
  float: right;
}
.cart-entry-box .one-price,
.cart-entry-box .quantity,
.cart-entry-box .total-price {
  display: inline-block;
  text-align: center;
  width: 122px;
  position: relative;
  vertical-align: top;
}
.cart-entry-box .quantity {
  width: 88px;
}
.preview-item .products-check .markup {
  float: left;
}
.preview-item .products-check .markup span {
  color: #999;
}
.preview-item .products-check .count {
  line-height: 26px;
  padding: 12px 8px 11px 8px;
}
.preview-item .products-check .markup .textarea {
  width: 300px;
  padding: 2px 10px;
  line-height: 24px;
  height: 50px;
  border: 1px solid #e5e5e5;
  border-radius: 1px;
  display: block;
  margin-bottom: 10px;
  color: #333;
  resize: none;
}
.preview-item .products-check .subtotal {
  float: right;
  text-align: right;
  padding-bottom: 5px;
}
.preview-item .products-check .subtotal .normal-price {
  font-weight: 400;
  display: inline-block;
}
.preview-item .products-check .subtotal .price {
  font-size: 14px;
  font-weight: initial;
  display: inline-block;
}

.balanceLink {
  border-radius: 4px;
  float: right;
  width: 150px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 20px;
  color: #999;
  background: #e7e7e7;
  cursor: not-allowed;
  border: none;
}
.checked {
  color: #fff;
  background: #f18e3d;
  cursor: pointer;
}
.no-submit{
  background-color: rgba(255, 242, 242, 1);
}
</style>
